import { http, authHeader } from '@/http-commons';

class VentaDetalleDataService {

    showDetailsVenta( ventaId ){
        return http.get(`api/v1/ventaDetalle/showDetails/${ventaId}`,{ headers: authHeader()});
    }

    graficaVenta(tipoSalidaId){
        return http.get(`api/v1/ventaDetalle/graficaVenta/${tipoSalidaId}`, { headers: authHeader()} );
    }
}
export default new VentaDetalleDataService();